import Vue from 'vue';
import Router from 'vue-router';
const allRoutes = concatArray();
Vue.use(Router);
export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: allRoutes,
});

function concatArray() {
  const modulesFiles = require.context('./modules', true, /\.js$/);
  const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const value = modulesFiles(modulePath);
    modules = [...modules, ...value.default];
    return modules;
  }, []);
  return modules;
}
